import { SimpleTable, TableActions } from '@core/components/Table';
import { TableActionButtonDelete, TableActionButtonEdit } from '@core/components/TableAction';
import TableActionContainer from '@core/components/TableAction/TableActionContainer';
import { useReduxLoading, useReduxMessage } from '@core/hooks';
import { permissaoUtils } from '@core/util/permissaoUtil';
import { formatCNPJ, formatTELEFONE } from '@format';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import React from 'react';
import { TransportadoraAction } from '../../store/transportadoraAction';
import { useTransportadora } from '../../store/transportadoraContext';

function TransportadoraTable({ onTour, onFetchData }) {
  const [state, dispatch] = useTransportadora();

  useReduxMessage(state.mensagem);
  useReduxLoading(state.carregandoRegistro);

  const actions = [
    {
      icon: <DeleteIcon />,
      name: 'excluir',
      tooltip: 'Excluir',
      show:
        permissaoUtils.transportadora().excluir &&
        (state.tipoSelecao === 'TODOS_FILTRO' || (state.selecionados && state.selecionados.length > 0)),
      onClick: () => {
        TransportadoraAction.removerRegistros(
          dispatch,
          state.selecionados.map((s) => s.id),
          state.tipoSelecao === 'TODOS_FILTRO' ? state.requestParams : null
        );
      },
    },
    /* {
      icon: <CloudUploadIcon />,
      name: 'importar',
      tooltip: 'Importar planilha',
      show: permissaoUtils.transportadora().cadastrar,
      onClick: () => console.log(state),
    }, */
    {
      icon: <AddIcon />,
      name: 'cadastrar',
      tooltip: 'Cadastrar',
      show: permissaoUtils.transportadora().cadastrar,
      onClick: () => dispatch(TransportadoraAction.setCadastrarRegistro()),
    },
  ];

  const columns = [
    {
      name: 'pessoa.nome',
      title: 'Nome',
      getCellValue: (value) => value?.pessoa?.nome || '-',
      sortingEnabled: true,
    },
    {
      name: 'pessoa.pessoaJuridica.cnpj',
      title: 'CNPJ',
      hideTooltip: true,
      getCellValue: (value) => (value?.pessoa?.pessoaJuridica ? formatCNPJ(value.pessoa.pessoaJuridica.cnpj) : '-'),
      sortingEnabled: true,
    },
    {
      name: 'pessoa.contatos.numero',
      title: 'Telefone principal',
      hideTooltip: true,
      getCellValue: (value) =>
        value?.pessoa?.contatos?.length ? formatTELEFONE(value.pessoa.contatos[0].numero) : '-',
      sortingEnabled: true,
    },
    {
      name: '',
      title: '',
      sortingEnabled: false,
      align: 'left',
      width: 125,
      getCellValue: (transportadora) => (
        <>
          <TableActionContainer onTour={onTour}>
            {permissaoUtils.transportadora().editar && (
              <TableActionButtonEdit
                className={'stepIconeEditar'}
                onClick={() => TransportadoraAction.editarRegistro(dispatch, transportadora, {})}
              />
            )}

            {permissaoUtils.transportadora().excluir && (
              <TableActionButtonDelete
                className={'stepIconeExcluir'}
                onClick={() => {
                  TransportadoraAction.removerRegistros(dispatch, [transportadora.id], {
                    ...state.requestParams,
                    tipoSelecao: 'NENHUM',
                  });
                }}
              />
            )}
          </TableActionContainer>
        </>
      ),
    },
  ];

  return (
    <>
      <SimpleTable
        defaultSorting={[{ columnName: 'pessoa.nome', direction: 'ASC' }]}
        columns={columns}
        fetchData={onFetchData}
        // fetchOnCreate
        rows={state.page.content}
        totalCount={state.page.totalElements}
        searchBy={state.requestParams.q}
        loading={state.carregandoRegistros}
        selection={state.selecionados}
        onSelectionChange={(params) => dispatch(TransportadoraAction.setSelecionados(params))}
        selectionType={state.tipoSelecao}
        onSelectionTypeChange={(params) => {
          dispatch(TransportadoraAction.setTipoSelecao(params));
        }}
        onRowClick={(params) => TransportadoraAction.visualizarRegistro(dispatch, params)}
        onCurrentPageChange={(params) => dispatch(TransportadoraAction.setCurrentPage(params))}
        onPageSizeChange={(params) => dispatch(TransportadoraAction.setPageSize(params))}
        onSortingChange={(params) => dispatch(TransportadoraAction.setSorting('params'))}
        params={state.filtroAvancado}
        contemFiltroAvancado
      />
      {(permissaoUtils.transportadora().cadastrar || permissaoUtils.transportadora().excluir) && (
        <TableActions className={'stepPlusButton'} actions={actions} />
      )}
    </>
  );
}

export default TransportadoraTable;
